import { Maybe } from '@sso/common-types';

import { getDecodedUxStateCookie } from './cookie';

export const getNativeIdFromUxstate = (): Maybe<string> => {
  const uxState = getDecodedUxStateCookie();
  return uxState?.nativeId?.type ?? null;
};

export const isIosNativeApp = (nativeId: Maybe<string>) => {
  return nativeId != null && nativeId.includes('ios');
};

export const isNativeApp = (nativeId: Maybe<string>) => {
  return nativeId != null;
};
